import Reveal from './Reveal';

function SectionHead({ eyebrow, title, accent, text, light = false }) {
  return (
    <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
      <div>
        <p className="eyebrow">{eyebrow}</p>
        <h2 className={`h-display mt-4 text-5xl md:text-7xl ${light ? 'text-white' : ''}`}>
          {title} <em className="text-brick">{accent}</em>
        </h2>
      </div>
      {text && <p className={`max-w-sm text-sm leading-7 ${light ? 'text-white/65' : 'text-stone'}`}>{text}</p>}
    </Reveal>
  );
}

export default SectionHead;
